<template>
  <div id="calendar" class="calendar">
    <div>
      <img src="@/assets/icons/calendar.svg" alt="" />
      <h2>Your Priority Window has ended.</h2>
      <p>
        Please contact your Stadium Experience Account Executive to discuss
        alternate options.
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#calendar {
  background: url("~@/assets/images/booking.jpg");
  background-size: cover;
  display: grid;
  place-items:center;
  > div {    
    overflow:hidden;
    max-width: 500px;
    margin: 25px auto;    
    background: rgba(0, 0, 0, 0.20);    
    display: flex;
    flex-direction: column;
    gap:15px;
    justify-content: center;
    align-items: center;
    padding:125px;
    color:var(--white);
    img {
        margin-bottom: 45px;
    }
  }
}
h2 {
    margin:0;
    text-transform: uppercase;
}
</style>